import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Button, CircularProgress, Grid, TextField, Typography, } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import { documentValidation, handleFileUpload } from '../../../services/Functions';
import "../ChangeOfAttributes/ChangeOfAttributesForm.scss";
import { documentExtensions } from '../../../utils/PortalName';
import Error from '../../../components/error/error';


const Changeoftariffupdatedocuments = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_applicant_cnic_front: null,
        iv_applicant_cnic_back: null,
        iv_owenership_document: null,
        iv_authority_letter: null,
        iv_other_documents: null,
    }

    // Documents states
    const [applicantCNICFront, setApplicantCnicDocumentFront] = useState('');
    const [applicantCNICBack, setApplicantCnicDocumentBack] = useState('');
    const [ownerShip, setOwnerShip] = useState('');
    const [authorityLetter, setAuthorityLetter] = useState("");
    const [otherDocuments, setOtherDocuments] = useState('');

    // Thumbnail states
    const [applicantCNICFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState('');
    const [applicantCNICBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState('');
    const [ownerShipThumbnail, setOwnerShipThumbnail] = useState('');
    const [authorityLetterThumbnail, setAuthorityLetterThumbnail] = useState("");
    const [otherDocumentsThumbnail, setOtherDocumentsThumbnail] = useState('');

    // Error states
    const [applicantCNICFrontError, setApplicantCnicDocumentFrontError] = useState('');
    const [applicantCNICBackError, setApplicantCnicDocumentBackError] = useState('');
    const [ownerShipError, setOwnerShipError] = useState('');
    const [authorityLetterError, setAuthorityLetterError] = useState("");
    const [otherDocumentsError, setOtherDocumentsError] = useState('');
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false)
    const [error, setError] = useState('');

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    const officeCode = parseInt(JSON.parse(window.localStorage.getItem('user-office-code')))
    const officeHierarchy = parseInt(JSON.parse(window.localStorage.getItem('user-hierarchy')))
    const showAllApplicationsFlag = JSON.parse(window.localStorage.getItem('show-all-applications-flag'));

    var token = JSON.parse(window.localStorage.getItem('user-token'))

    const navigate = useNavigate();

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData.applicantCNICFront) {
            values.iv_applicant_cnic_front = dialogRowData.applicantCNICFront
            setApplicantCnicDocumentFrontThumbnail(dialogRowData.applicantCNICFront)
        }
        if (dialogRowData.applicantCNICBack) {
            values.iv_applicant_cnic_back = dialogRowData.applicantCNICBack
            setApplicantCnicDocumentBackThumbnail(dialogRowData.applicantCNICBack)
        }
        if (dialogRowData.owenershipImage) {
            values.iv_owenership_document = dialogRowData.owenershipImage
            setOwnerShipThumbnail(dialogRowData.owenershipImage)
        }
        if (dialogRowData.authorityLetterImage) {
            values.iv_authority_letter = dialogRowData.authorityLetterImage
            setAuthorityLetter(dialogRowData.authorityLetterImage)
        }
        if (dialogRowData.otherDocuments) {
            values.iv_other_documents = dialogRowData.otherDocuments
            setOtherDocuments(dialogRowData.otherDocuments)
        }
    }, [dialogRowData])

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_applicant_cnic_front: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_applicant_cnic_back: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_owenership_document: Yup.mixed().required('Please upload ownership document in jpg, jpeg, png or pdf format.'),
                iv_authority_letter: Yup.mixed().optional(),
                iv_other_documents: Yup.mixed().optional(),
            }),
            onSubmit: async (values, { resetForm }) => {
                setIsLoadingSpinner(true);
                let userName = JSON.parse(window.localStorage.getItem('user-name'))
                var formdata = new FormData();

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                formdata.append("applicantCNICFront", applicantCNICFrontThumbnail);
                formdata.append("applicantCNICBack", applicantCNICBackThumbnail);
                formdata.append("owenershipImage", ownerShipThumbnail);
                if (authorityLetterThumbnail) {
                    formdata.append("authorityLetter", authorityLetterThumbnail);
                } else {
                    formdata.append("authorityLetter", '');
                }

                if (otherDocumentsThumbnail) {
                    formdata.append("otherDocuments", otherDocumentsThumbnail);
                } else {
                    formdata.append("otherDocuments", '');
                }
                formdata.append("applicationId", dialogRowData.applicationId);


                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                await fetch(cfpBaseUrl + "changeOfTariff/updateChangeOfTariffDocuments", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            var formdata = new FormData();
                            formdata.append("applicationNo", dialogRowData.applicationId);
                            const myHeaders = new Headers();
                            myHeaders.append("Authorization", token);;
                            formdata.append("applicantCNICFrontFlag", "");
                            formdata.append("applicantCNICBackFlag", "");
                            formdata.append("owenershipDocumentFlag", "");
                            formdata.append("otherDocumentsFlag", "");
                            formdata.append("authorityLetterFlag", "");
                            var requestOptions = {
                                method: 'POST',
                                body: formdata,
                                headers: myHeaders,
                                redirect: 'follow',
                            };
                            fetch(cfpBaseUrl + "changeOfTariff/updateCOTDocumentFlag", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    if (result.status === "200") {
                                        var formdata = new FormData();
                                        formdata.append("applicationId", dialogRowData.applicationId);
                                        formdata.append("objectionStatus", 2);
                                        formdata.append("remarks", "Documents Reuploaded");
                                        formdata.append("remarksDetail", "-");
                                        formdata.append("lastModifiedBy", userName);
                                        const myHeaders = new Headers();
                                        myHeaders.append("Authorization", token);;
                                        var requestOptions = {
                                            method: 'POST',
                                            body: formdata,
                                            headers: myHeaders,
                                            redirect: 'follow',
                                        };
                                        fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
                                            .then(response => response.json())
                                            .then(result => {
                                                if (result.status === '200') {
                                                    try {
                                                        setIsLoadingSpinner(false)
                                                    }
                                                    catch (error) {
                                                        console.log(error, 'Printing error')
                                                    }
                                                    setTimeout(() => {
                                                        navigate('/change-of-tariff-table')
                                                    }, 2000)
                                                }
                                                else {
                                                    console.log(result.message)
                                                }
                                            })
                                            .catch(error => console.log('error', error));
                                    }
                                })
                                .catch(error => console.log('error', error));
                        }
                        else {
                            setIsLoadingSpinner(false)
                        }
                    })
                    .catch(error => {
                        setIsLoadingSpinner(false)
                        console.log(error);
                    });
            }
        })

    //Function to set states of documents
    const ApplicantCnicDocumentFront = (event) => {
        const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicDocumentFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
    };

    const ApplicantCnicDocumentBack = (event) => {
        const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicDocumentBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
    };

    const OwnershipDocument = (event) => {
        const newFileName = 'ownership.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setOwnerShip, setOwnerShipError, setOwnerShipThumbnail, newFileName);
    };

    const AuthorityLetter = (event) => {
        const newFileName = 'authorityLetter.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setAuthorityLetter, setAuthorityLetterError, setAuthorityLetterThumbnail, newFileName);
    };

    const OtherDocuments = (event) => {
        const newFileName = 'otherDocuments.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setOtherDocuments, setOtherDocumentsError, setOtherDocumentsThumbnail, newFileName);
    };

    const errorCloses = () => {
        setError('')
    }

    return (
        <Grid container className='nC'>
            <Box className='nCContainer'>
                <Typography variant='h6' className='heading'>
                    Change of Tariff Form
                </Typography>
                <Box className="progressBarBackground">
                    <Box className="progressBarContainer">
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    (dialogRowData.applicantCNICFront && dialogRowData.applicantCNICBack) || (applicantCNICFront && applicantCNICBack)
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>1</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Applicant's CNIC.</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.owenershipImage || ownerShip
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>2</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Ownership Documents</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.authorityLetter || (authorityLetter)
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>3</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Test Report</Typography>
                        </Box>
                    </Box>
                </Box>

                <form className='ncform' style={{ marginRight: '20px' }}>
                    <Typography variant="h6" className='groupTitle' >
                        Application Details
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <Typography className='fieldLabel' > Application Id</Typography>
                            <TextField
                                required
                                type='text'
                                name="iv_applied_load"
                                value={dialogRowData.applicationId}
                                disabled
                                id="iv_applied_load"
                                className='textInputField'
                            />
                        </Grid>
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                    </Grid>
                    <Typography variant="h6" className='groupTitle'>
                        Documents
                    </Typography>
                    <Grid container spacing={1} className='documentsContainer' >
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
                            <Box className='documentError'>{(errors.iv_applicant_cnic_front && touched.iv_applicant_cnic_front) || (errors.iv_applicant_cnic_back && touched.iv_applicant_cnic_back) ? (errors.iv_applicant_cnic_front) : null}</Box>
                            <Box className='documentError'>{(applicantCNICFrontError ? applicantCNICFrontError : '') || (applicantCNICBackError ? applicantCNICBackError : '')}</Box>
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICFront ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={applicantCNICFrontThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.applicantCNICFrontFlag || dialogRowData.applicantCNICFrontFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicDocumentFront} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICFront ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocumentFront('') }} />}  >
                                                {applicantCNICFrontThumbnail && <img src={applicantCNICFrontThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicDocumentFront} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICBack ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={applicantCNICBackThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.applicantCNICBackFlag || dialogRowData.applicantCNICBackFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicDocumentBack} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICBack ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocumentBack('') }} />}  >
                                                {applicantCNICBackThumbnail && <img src={applicantCNICBackThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicDocumentBack} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >2- Ownership Documents</Typography>
                            <Box className='documentError'>{errors.iv_owenership_document && touched.iv_owenership_document ? (errors.iv_owenership_document) : null}</Box>
                            <Box className='documentError'>{ownerShipError ? ownerShipError : ''}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.owenershipImage ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={ownerShipThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.owenershipImageFlag || dialogRowData.owenershipImageFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwnershipDocument} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    ownerShip ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOwnerShip('') }} />}  >
                                                {ownerShipThumbnail && <img src={ownerShipThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwnershipDocument} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >3- Authority Letter</Typography>
                            <Box className='documentError'>{errors.iv_authority_letter && touched.iv_authority_letter ? (errors.iv_authority_letter) : null}</Box>
                            <Box className='documentError'>{authorityLetterError ? authorityLetterError : ""}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.authorityLetter ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={authorityLetterThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.authorityLetterFlag || dialogRowData.authorityLetterFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_authority_letter' name='iv_authority_letter' type="file" onChange={AuthorityLetter} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    authorityLetter ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setAuthorityLetter('') }} />}  >
                                                {authorityLetterThumbnail && <img src={authorityLetterThumbnail} alt="Owner CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_authority_letter' name='iv_authority_letter' type="file" onChange={AuthorityLetter} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >4- Other Documents</Typography>
                            <Box className='documentError'>{errors.iv_other_documents && touched.iv_other_documents ? (errors.iv_other_documents) : null}</Box>
                            <Box className='documentError'>{otherDocumentsError ? otherDocumentsError : ''}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.otherDocuments ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={otherDocumentsThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.otherDocumentsFlag || dialogRowData.otherDocumentsFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_other_documents' name='iv_other_documents' type="file" onChange={AuthorityLetter} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    otherDocuments ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setAuthorityLetter('') }} />}  >
                                                {otherDocumentsThumbnail && <img src={otherDocumentsThumbnail} alt="Owner CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_other_documents' name='iv_other_documents' type="file" onChange={AuthorityLetter} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: '8%', textAlign: 'right' }}>
                        <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant='contained' component="label" type='submit' onClick={handleSubmit} disabled={isLoadingSpinner}>
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </Box>
                </form >
            </Box >
        </Grid >
    )
}

export default Changeoftariffupdatedocuments
